/**
 * Main application layout shell with persistent sidebar navigation.
 * Wraps authenticated pages and fetches available modules. The sidebar
 * menu is driven by modules.list, so module enable/disable and team
 * access rules control which entries appear.
 */
import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";

import { trpc } from "@/lib/trpc";

/**
 * Main application shell with sidebar layout
 *
 * Layout: flex row — persistent Sidebar on the left, scrollable main
 * content area on the right.
 */
export function AppShell() {
	const modulesQuery = trpc.modules.list.useQuery();

	return (
		<div className="flex h-screen overflow-hidden">
			<Sidebar modules={modulesQuery.data ?? { groups: [], ungrouped: [] }} />
			<main className="flex-1 overflow-y-auto min-w-0">
				<Outlet />
			</main>
		</div>
	);
}
